import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FparTableCellIssue } from '@core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-view-issue-link',
  templateUrl: './view-issue-link.component.html',
  styleUrls: ['./view-issue-link.component.scss'],
  standalone: false,
})
export class ViewIssueLinkComponent {
  @Input() currentSubIssueIndex: number;
  @Input() subIssue: FparTableCellIssue;
  @Input() subIssueIndex: number;

  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Output() next = new EventEmitter<any>();
  @Output() popoverClose = new EventEmitter<any>();
  @Output() popoverOpen = new EventEmitter<any>();
  @Output() previous = new EventEmitter<any>();
  /* eslint-enable @typescript-eslint/no-explicit-any */

  constructor() {}

  public get isOpen(): boolean {
    return this.currentSubIssueIndex === this.subIssueIndex;
  }

  public closePopover(): void {
    this.popoverClose.emit(-1);
  }

  public nextSubIssue(): void {
    this.next.emit();
  }

  public openPopover(): void {
    this.popoverOpen.emit(this.subIssueIndex);
  }

  public previousSubIssue(): void {
    this.previous.emit();
  }

  public togglePopover($event): void {
    $event.preventDefault();
    if (this.isOpen) {
      this.closePopover();
    } else {
      this.openPopover();
    }
  }
}
